import { el } from "@dhx/ts-common/dom";
import { getFormItemCss, getValidationMessage } from "../helper";
import { Input } from "./input";
import { ITextArea } from "../types";
import { isDefined } from "@dhx/ts-common/core";


export class Textarea extends Input {
	public config: ITextArea&{type: any};
	protected _draw() {
		const { id,	value, disabled, name, placeholder,	required, resizable, readOnly, validation } = this.config;
		return el("div.dhx_form-group.dhx_form-group--textarea", {
			class: getFormItemCss(this.config, Boolean(required) || Boolean(validation))
		}, [
			this._drawLabel(),
			el(".dhx_input__wrapper", [
				el("textarea.dhx_input.dhx_input--textarea", {
					type: "text",
					id,
					placeholder: placeholder || "",
					value: isDefined(value) ? value : "",
					name: name || "",
					disabled,
					required,
					readOnly,
					onblur: this._handlers.onblur,
					oninput: this._handlers.oninput,
					style: {
						resize: resizable ? "both" : "none",
					}
				}),
				getValidationMessage(this.config) && el("span.dhx_input__caption", {
				}, getValidationMessage(this.config))
			]),
		]);
	}
}